import React from "react";

/**
 * UAE public-form phone input. The country calling code is intentionally fixed
 * so the value supplied to the OTP flow is always normalized as +971XXXXXXXXX.
 * Pasting a full UAE number is supported; only the local nine digits remain.
 */
export const normalizeUaeLocalPhone = (value = "") => {
  let digits = String(value).replace(/\D/g, "");
  if (digits.startsWith("971")) digits = digits.slice(3);
  if (digits.startsWith("0")) digits = digits.slice(1);
  return digits.slice(0, 9);
};

export default function UaeWhatsAppPhoneInput({
  value,
  onChange,
  placeholder = "50 123 4567",
  className = "",
  prefixClassName = "border-white/10 bg-black/15 text-amber-200/95",
  testId,
  required = false,
  ...props
}) {
  const handleChange = (event) => onChange(normalizeUaeLocalPhone(event.target.value));

  return (
    <div className="relative w-full">
      <span
        aria-hidden="true"
        className={`pointer-events-none absolute inset-y-1 left-1 z-10 flex items-center rounded-lg border px-3 text-sm font-semibold tracking-wide ${prefixClassName}`}
      >
        +971
      </span>
      <input
        {...props}
        required={required}
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        minLength={9}
        maxLength={9}
        value={normalizeUaeLocalPhone(value)}
        onChange={handleChange}
        placeholder={placeholder}
        aria-label="UAE WhatsApp number; country code +971"
        data-testid={testId}
        className={`${className} pl-[5.25rem]`}
      />
    </div>
  );
}
